export const laoHotelPayments: Record<string, string> = {
  Unpaid: 'ຍັງບໍ່ຊຳລະ',
  'Partially paid': 'ຊຳລະບາງສ່ວນ',
  'Payment status': 'ສະຖານະການຊຳລະ',
  'All payment statuses': 'ທຸກສະຖານະການຊຳລະ',
  'Company balance due': 'ຍອດຄ້າງຊຳລະຂອງບໍລິສັດ',
  'Invoice awaiting posting': 'ໃບແຈ້ງໜີ້ລໍຖ້າລົງບັນຊີ',
  'Invoice balance due': 'ໃບແຈ້ງໜີ້ມີຍອດຄ້າງຊຳລະ',
  'Room & services': 'ຄ່າຫ້ອງ ແລະ ບໍລິການ',
  'Services & fees': 'ຄ່າບໍລິການ ແລະ ຄ່າທຳນຽມ',
  'Deposit marker': 'ເຄື່ອງໝາຍມັດຈຳ',
  'Payment method': 'ວິທີຊຳລະເງິນ',
  'Bank transfer / QR': 'ໂອນຜ່ານທະນາຄານ / QR',
  'Card (paid externally)': 'ບັດ (ຊຳລະຜ່ານເຄື່ອງຮັບບັດແລ້ວ)',
  'Received into': 'ຮັບເງິນເຂົ້າບັນຊີ',
  'Choose a cash or bank account': 'ເລືອກບັນຊີເງິນສົດ ຫຼື ທະນາຄານ',
  'No matching LAK account is available. Ask an administrator to add one in Cash & assets.':
    'ບໍ່ມີບັນຊີເງິນກີບທີ່ກົງກັບວິທີຊຳລະ. ໃຫ້ຜູ້ດູແລເພີ່ມບັນຊີໃນ ເງິນສົດ ແລະ ຊັບສິນ.',
  'Payment reference (optional)': 'ເລກອ້າງອີງການຊຳລະ (ບໍ່ບັງຄັບ)',
  'Transfer reference or terminal receipt': 'ເລກອ້າງອີງການໂອນ ຫຼື ໃບຮັບເງິນຈາກເຄື່ອງຮັບບັດ',
  'Record money already received from the guest. A receipt updates the folio and accounts.':
    'ບັນທຶກເງິນທີ່ຮັບຈາກແຂກແລ້ວ. ໃບຮັບເງິນຈະປັບຍອດໃບບັນຊີແຂກ ແລະ ບັນຊີ.',
  'This folio is paid. There is no outstanding balance.': 'ໃບບັນຊີນີ້ຊຳລະແລ້ວ. ບໍ່ມີຍອດຄ້າງຊຳລະ.',
  'Payment for': 'ຊຳລະສຳລັບ',
  'Full folio balance': 'ຍອດຄ້າງຊຳລະທັງໝົດ',
  'Unbilled room charges': 'ຄ່າຫ້ອງທີ່ຍັງບໍ່ອອກໃບແຈ້ງໜີ້',
  'Unbilled services & fees': 'ຄ່າບໍລິການ ແລະ ຄ່າທຳນຽມທີ່ຍັງບໍ່ອອກໃບແຈ້ງໜີ້',
  'Amount received (LAK)': 'ຈຳນວນເງິນທີ່ຮັບ (ກີບ)',
  'Selected balance': 'ຍອດທີ່ເລືອກຊຳລະ',
  'Folio balance after payment': 'ຍອດຄ້າງຫຼັງຊຳລະ',
  'Unbilled charges will be invoiced to the guest and posted with the configured tax.':
    'ລາຍການທີ່ຍັງບໍ່ອອກໃບແຈ້ງໜີ້ ຈະອອກໃຫ້ແຂກ ແລະ ລົງບັນຊີພ້ອມອາກອນທີ່ຕັ້ງໄວ້.',
  'Card and QR payments must be completed on your terminal or banking app before recording here.':
    'ຕ້ອງຊຳລະຜ່ານບັດ ຫຼື QR ໃຫ້ສຳເລັດໃນເຄື່ອງຮັບບັດ ຫຼື ແອັບທະນາຄານກ່ອນບັນທຶກທີ່ນີ້.',
  'The old deposit marker is not a payment. Check existing receipts before recording it again.':
    'ເຄື່ອງໝາຍມັດຈຳເກົ່າບໍ່ແມ່ນລາຍການຊຳລະ. ກວດໃບຮັບເງິນກ່ອນບັນທຶກຊ້ຳ.',
  'Payment recorded': 'ບັນທຶກການຊຳລະແລ້ວ',
  'Review billing documents': 'ເບິ່ງເອກະສານເກັບເງິນ',
  'No balance due': 'ບໍ່ມີຍອດຄ້າງຊຳລະ',
  'Paid in full': 'ຊຳລະຄົບແລ້ວ',
  'Balance due': 'ຍອດຄ້າງຊຳລະ',
  'Payments received': 'ເງິນຊຳລະທີ່ຮັບແລ້ວ',
  'Payment received': 'ຮັບເງິນຊຳລະແລ້ວ',
  'Voided payment': 'ລາຍການຊຳລະທີ່ຍົກເລີກ',
  'View receipt': 'ເບິ່ງໃບຮັບເງິນ',
  'Review deposit marker': 'ເບິ່ງເຄື່ອງໝາຍມັດຈຳ',
  'Legacy deposit marker': 'ເຄື່ອງໝາຍມັດຈຳເກົ່າ',
  'Check receipts; this marker does not reduce the balance':
    'ກວດໃບຮັບເງິນ; ເຄື່ອງໝາຍນີ້ບໍ່ຫຼຸດຍອດຄ້າງ',
  'Settle balance': 'ຊຳລະຍອດຄ້າງ',
  'Charge to room · pay later': 'ລົງຄ່າໃຊ້ຈ່າຍໃນຫ້ອງ · ຊຳລະພາຍຫຼັງ',
  'Pay now · payment already received': 'ຊຳລະຕອນນີ້ · ຮັບເງິນແລ້ວ',
  'Charge and payment recorded': 'ບັນທຶກຄ່າໃຊ້ຈ່າຍ ແລະ ການຊຳລະແລ້ວ',
  'Service payment including tax': 'ຄ່າບໍລິການລວມອາກອນ',
  'Only this service will be invoiced and paid. Other room and service balances stay unchanged.':
    'ອອກໃບແຈ້ງໜີ້ ແລະ ຊຳລະສະເພາະບໍລິການນີ້. ຍອດຄ້າງຄ່າຫ້ອງ ແລະ ບໍລິການອື່ນຍັງຄືເກົ່າ.',
  'This charge will be added to the guest folio for payment later.':
    'ຄ່າໃຊ້ຈ່າຍນີ້ຈະລົງໃນໃບບັນຊີແຂກເພື່ອຊຳລະພາຍຫຼັງ.',
  'Add charge & record payment': 'ເພີ່ມຄ່າໃຊ້ຈ່າຍ ແລະ ບັນທຶກການຊຳລະ',
  'Folio total (before tax)': 'ຍອດລວມໃບບັນຊີ (ກ່ອນອາກອນ)',
  'Tax on unbilled charges': 'ອາກອນສຳລັບລາຍການທີ່ຍັງບໍ່ອອກໃບແຈ້ງໜີ້',
  cash: 'ເງິນສົດ',
  bank_transfer: 'ໂອນຜ່ານທະນາຄານ / QR',
  card: 'ບັດ',
  other: 'ອື່ນໆ',
};
